import { render, staticRenderFns } from "./mr_widget_alert_message.vue?vue&type=template&id=1ed8f09b&"
import script from "./mr_widget_alert_message.vue?vue&type=script&lang=js&"
export * from "./mr_widget_alert_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports